import React, { useCallback } from "react"
import SliceColors from "../shared/SliceColors"
import usePersistedState from "../../hooks/usePersistedState"

const ColorsSection = ({ className, choices, customColors, onColorChange, onResetAll }) => {
  const [expanded, setExpanded] = usePersistedState("colors_expanded", false, { prefix: "rodg_" })
  const toggle = useCallback(() => setExpanded((v) => !v), [setExpanded])

  return (
    <div className={`section-card ${className}`}>
      <button
        type="button"
        className={`section-label rodg-section-toggle${expanded ? "" : " collapsed"}`}
        onClick={toggle}
        aria-expanded={expanded}
      >
        Colors
      </button>
      {expanded && (
        <SliceColors
          choices={choices}
          customColors={customColors}
          onColorChange={onColorChange}
          onResetAll={onResetAll}
        />
      )}
    </div>
  )
}

export default ColorsSection
